import React from 'react'
import { useContentShareControls, useContentShareState } from 'amazon-chime-sdk-component-library-react'
import { useTranslation } from 'react-i18next'
import { t as lt } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import { SxProps } from '@mui/material/styles'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'

import DesktopMacIcon from '@/components/ui/icons/DesktopMac'

import ControlBarItem from './ControlBarItem'

import colors from '@/assets/scss/_themes-vars.module.scss'

type ScreenShareControlProps = {
  sx?: SxProps
}

export default function ScreenShareControl(props: ScreenShareControlProps) {
  const { sx } = props
  const { t } = useTranslation()
  useLingui()
  const { toggleContentShare } = useContentShareControls()
  const { isLocalUserSharing } = useContentShareState()

  return (
    <ControlBarItem disableMargin>
      <Tooltip title={<span>{t('component.chimeSDK.screenShareControl.shareScreenButton.tooltip')}</span>} arrow>
        <Button variant="neutral" sx={sx} onClick={() => toggleContentShare()} aria-label={isLocalUserSharing ? lt`Stop screen sharing` : lt`Share screen`}>
          {isLocalUserSharing ? <CancelPresentationIcon htmlColor={colors.gray500} /> : <DesktopMacIcon />}
        </Button>
      </Tooltip>
    </ControlBarItem>
  )
}
